export default __webpack_public_path__ + "images/870dbf22443fa23480745089a0ac8de7-food.webp";